/* global AdyenConfiguration */
import { defer, pick, pickBy, each } from 'lodash';
import { compact } from 'lodash-es';
import { AdyenCheckout, ApplePay, Bancontact, Card, Dropin, GooglePay, PayPal, Klarna } from '@adyen/adyen-web';
import Form from 'components/form/Form';
import { adyenConfig, adyenPaymentMethodConfig, updateConfigs } from 'core/adyenConfig';
import { bindEmitterMethod, bindMethod } from 'helpers/bind';
import anime from 'animejs';
import { EASE_IN_OUT } from 'helpers/easings';
import CheckoutPage from 'navigation/pages/CheckoutPage';
import RadioGroup from 'components/radio-group/RadioGroup';
class CheckoutPayment extends CheckoutPage {
    validations;
    dropin;
    getModulesMap() {
        const modules = super.getModulesMap();
        delete modules.radioGroup;
        return {
            ...modules,
            creditForm: ['.credit-form', Form],
            radioGroup: ['.form .radio-group', RadioGroup],
            creditRadioGroup: ['.credit-form .radio-group', RadioGroup]
        };
    }
    askPreload(previousPage) {
        const script = this.el.querySelector('.config-adyen');
        if (script) {
            const parent = script.parentNode;
            parent.removeChild(script);
            const s = document.createElement('script');
            s.innerHTML = script.innerHTML;
            parent.appendChild(s);
            updateConfigs();
        }
        return super.askPreload(previousPage);
    }
    async show(previousPage) {
        if (adyenConfig) {
            const checkout = await AdyenCheckout(adyenConfig);
            this.dropin = new Dropin(checkout, {
                paymentMethodComponents: [Card, PayPal, GooglePay, ApplePay, Bancontact, Klarna],
                paymentMethodsConfiguration: {
                    ...adyenPaymentMethodConfig
                },
                onReady: () => {
                    this.refs.payNow.addEventListener('click', () => this.triggerSubmit());
                    this.onShowComplete();
                },
                onSelect: (activeComponent) => {
                    const showPayButton = activeComponent.type !== 'scheme';
                    this.refs.payNow.classList.toggle('paynow-hidden', showPayButton);
                    setTimeout(() => {
                        const checkbox = this.refs.adyen.querySelector('.adyen-checkout__checkbox__input');
                        const radioBox = this.refs.adyen.querySelector('.radio__box');
                        if (this.refs.adyen.contains(radioBox) || !checkbox)
                            return;
                        const fakeCheckbox = document.createElement('div');
                        fakeCheckbox.classList.add('radio__box');
                        checkbox.after(fakeCheckbox);
                    }, 20);
                }
            }).mount(this.refs.adyen);
        }
        return super.show(previousPage);
    }
    triggerSubmit = async () => {
        if (!this.dropin.isValid) {
            this.dropin.showValidation();
            return;
        }
        const cssVariables = {
            loadingProgress: 0
        };
        this.refs.payNow.classList.add('loading');
        const span = this.refs.payNow.querySelector('.button__text-inner').children[0];
        span.innerText = this.refs.payNow.dataset.loading;
        await anime({
            targets: cssVariables,
            loadingProgress: [0, 1],
            duration: 2000,
            easing: EASE_IN_OUT,
            begin: () => {
                this.refs.payNow.setAttribute('disabled', 'true');
            },
            update: () => {
                this.refs.payNow.style.setProperty('--loading-progress', `${cssVariables.loadingProgress}`);
            },
            complete: () => {
                this.refs.payNow.removeAttribute('disabled');
                this.dropin.submit();
                this.refs.payNow.classList.add('paynow-hidden');
            }
        }).finished;
    };
    bindEvents(add = true) {
        super.bindEvents(add);
        const method = bindEmitterMethod(add);
        const method2 = bindMethod(add);
        if (!Array.isArray(this.modules.radioGroup))
            this.modules.radioGroup = compact([this.modules.radioGroup]);
        this.modules.radioGroup.forEach(r => r[method]('change', this.onMethodChange, this));
        if (this.modules.creditRadioGroup)
            this.modules.creditRadioGroup[method]('change', this.onCreditChange, this);
        // this.onMethodChange()
        Array.from(this.el.querySelectorAll('[data-test-cc]')).forEach(b => b[method2]('click', this.onTestCard));
    }
    onTestCard = (event) => {
        event.preventDefault();
        const date = new Date();
        const data = {
            CT: event.currentTarget.getAttribute('data-test-cc'),
            CARDNO: event.currentTarget.getAttribute('data-test-number'),
            ECOM_CARDINFO_EXPDATE_YEAR: date.getFullYear(),
            ECOM_CARDINFO_EXPDATE_MONTH: date.getMonth() + 1,
            CVC: '123',
            CN: 'Test'
        };
        const { form } = this.modules;
        each(data, (val, key) => {
            const input = form.el.elements[key];
            switch (input.type) {
                case 'checkbox':
                    input.checked = !!val;
                    break;
                default:
                    input.value = val;
                    break;
            }
        });
        setTimeout(() => form.quickValid(), 10);
    };
    bindModules() {
        super.bindModules();
        const { form } = this.modules;
        if (!form)
            return;
        const validations = Object.assign({}, form.validations);
        const baseValidation = pick(validations, ['mode']);
        const cardValidations = pickBy(validations, (value, key) => key.match(/^(CT|CARDNO|ECOM_CARDINFO_EXPDATE_.+|CVC|CN)$/));
        this.validations = {
            default: validations,
            card: cardValidations,
            base: baseValidation
        };
        form.preventDefault = false;
    }
    onCreditChange(value, name) {
        this.modules.creditForm.submit();
    }
    onMethodChange(value, name, input) {
        if (!this.validations)
            return;
        defer(() => {
            const data = this.modules.radioGroup.reduce((memo, radio) => {
                memo[radio.name] = radio.value;
                return memo;
            }, {});
            const schema = { ...this.validations.base };
            const { form } = this.modules;
            if (input && name === 'mode') {
                if (input.hasAttribute('data-action')) {
                    form.action = input.getAttribute('data-action');
                    form.el.action = form.action;
                }
            }
            if (data.mode === 'card')
                Object.assign(schema, this.validations.card);
            form.updateSchema(schema);
            setTimeout(() => form.quickValid(), 10);
        });
    }
    resize() {
        super.resize();
    }
    flush() {
        super.flush();
    }
}
export default CheckoutPayment;
